import React, { use, useEffect } from 'react'

import { useNavigate } from 'react-router-dom'
import { Box, Button, Text, VStack } from '@chakra-ui/react'

import { HeaderContext } from '@/context/Header'
import { isAllowlistedForLiveTranscription } from '@/helpers/is-allowlisted'
import { useUser } from '@/react-query/user'
import ArrowLeftLong from '@/views/assets/ArrowLeftLong'
import { useDocumentTitle } from '@/views/hooks/useDocumentTitle'

import { Billing } from './Billing'
import { Consent } from './Consent'
import { DeleteOldInterviews } from './DeleteOldInterviews'
import { EmailNotifications } from './EmailNotifications'
import { LiveTranscriptionSettings } from './LiveTranscriptionSettings'
import { NotetakerSettings } from './Notetaker'
import { ProfileSettings } from './Profile'
import { VideoRecordingSettings } from './VideoRecordingSettings'

export const UserSettings: React.FC = () => {
  useDocumentTitle('Settings')
  const { setMiddleContent } = use(HeaderContext)
  const user = useUser()

  const navigate = useNavigate()
  useEffect(() => {
    setMiddleContent(
      <>
        <Button
          as={'div'}
          variant={'brand-solid-white'}
          rounded={'full'}
          px={'1.15rem'}
          display={{
            base: 'none',
            sm: 'flex',
          }}
          ml={6}
          onClick={async () => {
            navigate('/home')
          }}
          cursor={'pointer'}
        >
          <ArrowLeftLong /> &nbsp;&nbsp;&nbsp;Interviews
        </Button>
        <Box
          ml={'2.7rem'}
          fontWeight={'bold'}
          display={{
            base: 'none',
            lg: 'flex',
          }}
          alignItems={'baseline'}
        >
          <Text fontSize={'2xl'}>Settings</Text>
        </Box>
      </>,
    )
    // Reset when unmounting
    return () => setMiddleContent(null)
  }, [])

  return (
    <VStack mt={10} spacing={10} minW={'80%'} maxW={'900px'} mx={'auto'}>
      <ProfileSettings />
      <Billing />
      <NotetakerSettings />
      <EmailNotifications />
      <Consent />
      <VideoRecordingSettings />
      {isAllowlistedForLiveTranscription(user.data?.email) && (
        <LiveTranscriptionSettings />
      )}
      <DeleteOldInterviews />
    </VStack>
  )
}
